import React, { useId } from 'react';
interface Props {
  size?: 'xxs' | 'xs' | 'small' | 'medium' | 'large';
  stroke?: string;
  fill?: string;
  isActive?: boolean;
}
const makeDimmer = (color: string, percent: number = 30): string => {
  if (!color.startsWith('#') || (color.length !== 4 && color.length !== 7)) {
    return color;
  }
  let r, g, b;
  if (color.length === 4) {
    r = parseInt(color[1] + color[1], 16);
    g = parseInt(color[2] + color[2], 16);
    b = parseInt(color[3] + color[3], 16);
  } else {
    r = parseInt(color.slice(1, 3), 16);
    g = parseInt(color.slice(3, 5), 16);
    b = parseInt(color.slice(5, 7), 16);
  }
  r = Math.max(0, Math.floor(r * (1 - percent / 100)));
  g = Math.max(0, Math.floor(g * (1 - percent / 100)));
  b = Math.max(0, Math.floor(b * (1 - percent / 100)));
  return `#${r.toString(16).padStart(2, '0')}${g
    .toString(16)
    .padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
};
const Loading: React.FC<Props> = ({
  size = 'medium',
  stroke,
  fill = '#C4FAC3',
  isActive = true,
}) => {
  const trackColor = stroke || makeDimmer(fill, 30);
  const getSize = (
    size: 'xxs' | 'xs' | 'small' | 'medium' | 'large',
  ): number => {
    switch (size) {
      case 'xxs':
        return 10;
      case 'xs':
        return 15;
      case 'small':
        return 25;
      case 'medium':
        return 40;
      case 'large':
        return 60;
      default:
        return 25;
    }
  };
  const svgSize = getSize(size);
  const radius = 18;
  const circumference = 2 * Math.PI * radius;
  const arcLength = circumference * 0.5;
  const gapLength = circumference - arcLength;
  const uniqueId = useId();
  const gradientId = `loadingGradient-${uniqueId}`;
  return (
    <div
      className="flex items-center justify-center w-full h-full relative top-0 left-0"
      role="status"
      aria-label="Loading"
    >
      <svg
        className={`inline ${isActive ? 'animate-spin' : ''}`}
        width={svgSize}
        height={svgSize}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          {}
          <linearGradient
            id={gradientId}
            x1="2"
            y1="20"
            x2="38"
            y2="20"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0%" stopColor={fill} stopOpacity="0" />
            <stop offset="50%" stopColor={fill} stopOpacity="1" />
            <stop offset="100%" stopColor={fill} stopOpacity="0" />
          </linearGradient>
        </defs>
        {}
        <circle
          cx="20"
          cy="20"
          r={radius}
          stroke={trackColor}
          strokeWidth="4"
          fill="none"
          strokeOpacity="0.2"
        />
        {}
        <circle
          cx="20"
          cy="20"
          r={radius}
          stroke={`url(#${gradientId})`}
          strokeWidth="4"
          fill="none"
          strokeDasharray={`${arcLength} ${gapLength}`}
          strokeDashoffset="0"
          strokeLinecap="round"
          transform="rotate(0 20 20)"
        />
      </svg>
    </div>
  );
};
export default Loading;
